<template>
  <div class="FourLinkagePanel">
    <div class="h-topo_pw2" v-show="see" style="width:330px;height:550px; background:#000000; opacity: 0.80;border-radius:4px;" :style="PositionXY">

      <div class="topo-title" style="width:100%; ">
          	<i :class="['icon hero-icon '+icon+ ' '+ online +' h-topo_topwz_i']" ></i>
            <label class="topo_title_w200" style="margin: 12px 0 0 10px;" :title='serviceName'>{{$t('Topo.serviceName')}}：{{serviceName}}</label>
          
        	<a style="cursor:pointer;float: right;margin: 8px 0 0 0;">
	          <span @click="click()" class="e-btn-icon icon hero-icon hero-icon-remove-small"  style="color:#ddd;" :title="$t('Common.close')"></span>
	        </a> 
                         
      </div>
      
      <div class="topo-alarm" :style="styleColorVar" v-if='showAlarmNumBtn'>
	      	<span>{{$t('Alarm.alarm')}}:</span>     	
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot critical radius50" ></span>{{Level0AlarmCount}}</a>
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot major radius50"></span>{{Level1AlarmCount}}</a>	      		      		      	
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot minor radius50" ></span>{{Level2AlarmCount}}</a>
	      	<a @click="alarmShowOperation" style="color:dddddd;"><span class="h-icon h-icon-dot warning radius50"></span>{{Level3AlarmCount}}</a>
      </div>
      
      <div v-if="seeBottom" style="width:100%;height:520px;"> 
      		 
      		 <!-- Begin Form Type One -->
      		 <div class="h-topo_content" style="height:auto;width: 100%;">	
      		 
      		 	<label class="formTitle" style="padding: 10px 0 0 12px;">{{$t('Topo.runningStatus')}}</label>	
      		 	<div>      		 	
      		 		<div class="col-md-6" style="padding: 0 12px 0 12px;"><span> {{$t('Topo.cpuUsage')}} : </span> {{cpuUsage}} 	   </div>
					<div class="col-md-6" style="padding: 0 12px 0 12px;"><span> {{$t('Topo.memoryUse')}} : </span> {{memoryUsage}} 	 </div>   
      		 	</div>					 
		     </div>  
		      				
	      	 <hr style=" margin: 15px 5px 10px 12px;border-color: #dddddd;"/>
	      	 <!-- /.END Form Type One --> 
	      	 
	      	 <!-- Begin Form Type Two -->
		     <div style="min-height:180px;margin-top: 0;">		       		
		       		<ejs-grid ref='gridService' id='gridService' gridLines='None' :dataSource="ds5G" :enableHover='false'	       			
			                rowHeight="20" :allowSelection="true" :selectionSettings='selectOptions' :rowSelected="rowSelectedService">
			                <e-columns>	
			                	<e-column field='id' :visible='false' :isPrimaryKey='true'></e-column>	                   
			                    <e-column field='name' :headerText="$t('Topo.serviceName')" width='130' :template='nameTemplate'></e-column>	
			                    <e-column field='cpuUsage' :headerText="$t('Topo.cpuUsage')" width='80' ></e-column>
			                    <e-column field='memoryUsage' :headerText="$t('Topo.memoryUse')" width='80'></e-column>		                   
			                </e-columns>
	                </ejs-grid>
		     </div> 
		     <hr style=" margin: 15px 5px 10px 12px;border-color: #dddddd;"/>  
		     <!-- /.END Form Type Two -->
		       
		       
		    <!-- Begin Form Type Three -->		
		    <div>     
					<ejs-grid ref='gridPOD' id='gridPOD' gridLines='None' :dataSource="dsPOD" ::enableHover='false' 
					        rowHeight="20" :allowSelection='true' :selectionSettings='selectOptions' :rowSelected="rowSelectedPOD">
					        <e-columns>			                   
					            <e-column field='id' :visible='false' :isPrimaryKey='true'></e-column>
					            <e-column field='name' :headerText="$t('Topo.podName')" width='130' :template='nameTemplate'></e-column>
					            <e-column field='status' :headerText="$t('Topo.runningStatus')" width='70'></e-column>		
					            <e-column field='ip' :headerText="$t('Topo.ip')" width='100'></e-column>	                    
					        </e-columns>
					</ejs-grid>	
			</div>	      
		    <!-- /.END Form Type Three -->            

      </div>
    </div>
    
	    <!-- “告警弹窗展示” -->
	    <CustomDialog ref="oprDialog" :element="oprSetDialog.element" :styles="oprSetDialog.styles">
	      <template v-slot:dialog-content>
	        <AlarmShowDialog ref='alarmDetailDialog'></AlarmShowDialog>
	      </template>
	    </CustomDialog>
    	
		<template>
			<FourListLinkageContainer :fourListLinkageContainer='fourListLinkageContainer'></FourListLinkageContainer>
		</template> 
  </div>
</template>

<script>
	import CustomDialog from "../../components/common/CustomDialog";
	import AlarmShowDialog from "../../components/topoconfig/AlarmShowDialog";
	
	import FourListLinkageContainer from "../../components/topoconfig/FourListLinkageContainer.vue";
	
	import nameLinkTemplate from "../../components/topoconfig/template/nameLinkTemplate.vue";
	import { EventBus } from '../../plugins/eventBus';
	import {createNamespacedHelpers} from "vuex";
	const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');
  
	export default {
	    name: "FourListLinkagePanel",
	    components: {
	      CustomDialog,
	      AlarmShowDialog,
	      FourListLinkageContainer
	    },
		computed: {
	      ...mapGetters(['getPhysicalById']),
	    },
	    data() {
		    return {	
                styleColorVar:{},
				ds5G: [],
				dsPOD: [],
				nameTemplate: function () {
			         return { template : nameLinkTemplate}
			    },
			    selectOptions: { type: 'Single', mode: 'Row' },			
				cpuUsage: '0%',
				memoryUsage: '0M',
				Level0AlarmCount: 0,
				Level1AlarmCount: 0,
				Level2AlarmCount: 0,
				Level3AlarmCount: 0,
				postModel: function(){		        	
				    this.environmentId = '';
				    this.netElementId = '';
			    },
		        alarmDetailObj: { id: this.id},
		        typeData: [],
		        typeCode: "",
		        icon: "",
		        online: "",
		        PositionXY: "",
		        postUrl: "",	        
		        serviceName: '',
		        see: false,
		        seeBottom: false,
		        id: "",
		        type: "",
		        gridLines: 'None',
		        fourListLinkageContainer: {seeObj: false,  PositionXY: '', id: '', ip: '', name: '', namespace: '', status:'',  dsContainer: [] },
		        oprSetDialog: {
			        element: {
				            title: this.$t("Alarm.alarm"),
				            target: "#app",
				            isClose: true,
				            refName: "oprSetDia",
				            buttonGroup: [
					              {	click: this.dialogHide,
					                buttonModel: { content: this.$t("Topo.cancel") }
					              }
				            ]
			        },
			        styles: {
				            width: "810px",
				            height: "760px",
				            model: true,
				            visible: false,
			        }
				},
				showAlarmNumBtn: { type: Boolean, default: true },
		    };
	    },
	    props: ["fourListLinkagePanel","roleNe"],
	    methods: {
	    
		      rowSelectedService: function( args ){
	    			if(args !=null && args.data.children !=null)
		        		this.dsPOD = args.data.children;	        		
		        	else
		        		this.dsPOD = [];	        	
		      },
		      rowSelectedPOD: function( args) {
		      		
		      		this.fourListLinkageContainer.seeObj = true;
		      		this.fourListLinkageContainer.seeBottomObj = true;
		      		if(this.PositionXY == 'left:25px')
		      			this.fourListLinkageContainer.PositionXY = 'left:45px;'
		      		else
		      			this.fourListLinkageContainer.PositionXY = 'right:45px;'
		      		
		      		this.fourListLinkageContainer.id = args.data.id;
		      		this.fourListLinkageContainer.ip = args.data.ip;
		      		this.fourListLinkageContainer.name = args.data.name;
		      		this.fourListLinkageContainer.namespace = args.data.namespace;
		      		this.fourListLinkageContainer.status = args.data.status;
		      		this.fourListLinkageContainer.dsContainer = args.data.children;
		      
		      },
		      getNeAlarmCount(){
		      
		      		this.Level0AlarmCount = 0;			            	 			
					this.Level1AlarmCount = 0;			            	 			
					this.Level2AlarmCount = 0;
					this.Level3AlarmCount = 0;
					if(this.roleNe.indexOf(parseInt(this.id))!=-1){
						const principal = sessionStorage.getItem('principal');
						const user = JSON.parse(principal);
						const userId = user.userId;
						this.axios.get(`/lte/ems/topo/ne/findNeAlarmCount/${userId}/${this.id}`).then(response => {
				          if (response && response.data.errorCode === "SUCCESS") {
					            const result = response.data.resultVal;
					            if (result) {				            
					            	 for(var i = 0 ; i< result.length ;i++)
					            	 {
					            	 	if(result[i].level == 0)
					            	 		this.Level0AlarmCount = result[i].count ;
					            	 			
					            	 	if(result[i].level == 1)
					            	 		this.Level1AlarmCount = result[i].count ;
					            	 			
					            	 	if(result[i].level == 2)
					            	 		this.Level2AlarmCount = result[i].count ;
										
										if(result[i].level == 3)
					            	 		this.Level3AlarmCount = result[i].count ;
					            	 }
					            }
				          } 
			        });
					}
	    				        	
		      },
		      panelBoardGetData() {
		      
		      		//-- set default data
		      		this.dsPOD = [];
					this.ds5G = [];
					
			        let environmentId = 0;
			        if (this.parentId) {
				          let pNode = this.getPhysicalById(this.parentId);
				          if ( (Number(pNode.type) >= 30001 && Number(pNode.type) <= 30010) ) {
				            	environmentId = this.parentId;
				          } 
				          else {
				          		pNode = this.getPhysicalById(pNode.parentid);
				            	environmentId = pNode.parentid;
				          }
			        }	       
	
			        var postParams = new this.postModel();
					postParams.environmentId = environmentId;
					postParams.netElementId = this.id;			
					
			        this.axios.post(this.postUrl, postParams).then(response => {
				          if (response && response.data.errorCode === "SUCCESS") {
					            const result = response.data.resultVal;
					            if (result) {
					            				            
					            	this.ds5G = result.k8sService;
					            	this.filterInit();
					            }
				          } 
				         
			        });
			        
		      }, 
		      filterInit(){
		      	
		      		this.cpuUsageList = [];
		      		this.memoryUsageList = [];
			        this.cpuUsage = '0%';
			        this.memoryUsage = '0M';
			        
		      		//-- filter 1st level	      		
		      		for( var i = 0 ; i < this.ds5G.length ; i++)
		      		{
		      			//-- init service level cpu / momory
		      			this.ds5G[i].cpuUsageList = [];
		      			this.ds5G[i].memoryUsageList = [];
		      			
		      			if(this.ds5G[i].children != null && this.ds5G[i].children.length > 0)
		      			{	      				
		      				this.recursiveChildren(this.ds5G[i], this.ds5G[i].children, 1);
		      			}				
		      		}      		
		      		
		      		var cpu = 0, memory = 0;
		      		for( var i = 0 ; i < this.ds5G.length ; i++)
		      		{
		      			if(this.ds5G[i].cpuUsageList.length > 0)
		      			{
		      				var cpuSum = this.sumArray(this.ds5G[i].cpuUsageList);
		      				cpu += cpuSum ;
		      				this.ds5G[i].cpuUsage =  cpuSum.toFixed(2) + '%'; 
		      			}		      				
		      	
		      			if(this.ds5G[i].memoryUsageList.length > 0)  
		      			{
		      				var memorySum = this.sumArray(this.ds5G[i].memoryUsageList);
		      				memory += memorySum ;
		      				this.ds5G[i].memoryUsage =  memorySum.toFixed(2) + 'M'; 
		      				
		      			}  	
		      		}	
		      			      		
		      		this.cpuUsage = cpu.toFixed(2) +'%';   
		      		this.memoryUsage = memory.toFixed(2) + 'M';			
		      }, 
		      recursiveChildren(pService, pList, pLevel){
		      		
		      		if(pLevel > 2)
		      		{
		      			return;
		      		}	      			
		      		
		      		//-- only sum service Container
		      		if( pLevel == 2)
		      		{
		      			var filterCPU = pList.filter( w => (w.cpuUsage != null ));	      			
			      		var filterMemory = pList.filter( w => (w.memoryUsage != null));	
			      						
						if(filterCPU != null && filterCPU.length > 0)
						{
							for( var j = 0; j < filterCPU.length ;j++)
							{
								var num = parseFloat( filterCPU[j].cpuUsage.replace(/%/,'') );
								if( num > 0)
								{
									pService.cpuUsageList.push(num);
								}										
							}						
						}
															
						if(filterMemory != null && filterMemory.length > 0)
						{
							for( var j = 0; j < filterMemory.length ;j++)
							{
								var num = parseFloat(filterMemory[j].memoryUsage.replace(/M/,''));
								if( num > 0)
								{
									pService.memoryUsageList.push(num);
								}								
							}												
						}
						
						return;					
		      		}      		      	
	
		         	//-- Recursive children
	      			for( var i = 0 ; i < pList.length ; i++)
		      		{
		      			if(pList[i].children != null && pList[i].children.length > 0)
		      			{
		      				this.recursiveChildren(pService, pList[i].children, pLevel + 1);
		      			}						
		      		}	      		
		      },
		      sumArray(arr){
		      
		      	 	var sum = eval(arr.join("+"));
		      	 	return sum;	      	 
		      }, 
			  getLang( key){
			  
			  		return this.$t(key);
			  },    
		      click() {
			        this.seeBottom = !this.seeBottom;
			        this.see = !this.see;
		      },	
		      alarmShowOperation() {
			        this.$refs.oprDialog.show();
			        var alarmId = this.id
			        this.$refs.alarmDetailDialog.beforeMount(alarmId);
		
		      },
		      dialogHide() {
			        this.$refs.oprDialog.clear();
			        this.$refs.oprDialog.close();
			  },
			  queryTopoConfig(){
				const url = "";
				this.axios.get(`/lte/ems/sysmanager/systemtopoconfig/querySystemTopoConfig`).then(response => {
					if (response && response.status === 200) {
					if(0==response.data.resultVal[0].alarmNumSet){
						this.showAlarmNumBtn = false;
					}else{
						this.showAlarmNumBtn = true;
						// this.$refs.baseBtn.queryAlarmNum();
						
					}
					}
				})
			  }
	    },	
	    mounted() {
		  this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
		  this.queryTopoConfig();
		},
	    watch: {
	      //父子动态传值
	      fourListLinkagePanel: {
	        handler: function(newVal, oldVal) {        
	        	  
	        	  var changed = (newVal.idObj != this.id) ? true : false; 
	        	  
		          this.see = newVal.seeObj;
		          this.seeBottom = newVal.seeBottomObj;	          
		          this.id = newVal.idObj;
		          this.parentId = newVal.parentId;
		          this.type = newVal.typeObj;
		          this.serviceName = newVal.serviceName;
		          if(newVal.onlineObj===1){
		            this.online='h-pm-iconOnline';
		          }       
		          else if(newVal.onlineObj===0){
		            this.online='h-pm-iconOffline';
		          }
		          
		          this.PositionXY = newVal.PositionXY;	//-- panel position
		          this.typeCode = newVal.typeCode;
				  this.icon = newVal.icon;
				  this.postUrl = newVal.postUrl;
		          
		          if(document.getElementsByClassName('scroll').length > 0) //-- scroll to top  
		          	document.getElementsByClassName('scroll')[0].scrollTop = 0; 	          
		          
		          if(newVal.seeObj == true && changed)
		          {
		          		this.panelBoardGetData();
		          		this.getNeAlarmCount();
		          }
		          
	        },
	        deep: true
	      }
	    }
  };
</script>

<style>
div.topo-alarm
{
	float: left;
    width: 100%;
    padding: 0 0 0 12px;
    color: #dddddd;
}

.topo-alarm a
{
	margin: 0 10px 0 10px;
	color: #dddddd;
	cursor: pointer;
	text-decoration: underline;
}

.topo-alarm .radius50
{
	width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
}

#gridService, #gridPOD{

	background: #000000;
    border: 0 none;
}

.FourLinkagePanel .e-grid .e-gridheader
{
    background: #000000;
    border: 0 none;
    color: #dddddd;
}

.FourLinkagePanel.e-gridheader
{
    border: 0 none;
    color: #dddddd;
}

.FourLinkagePanel .e-grid .e-headercell, topoPanel .e-grid .e-detailheadercell
 {
    background: #000000;
    color: #dddddd;
}

.FourLinkagePanel .e-rowcell, .topoPanel .e-rowcell
{
	color: #dddddd;
}

.FourLinkagePanel .e-grid .e-content,
.FourLinkagePanel .e-grid .e-gridcontent
{
	background: #000000;
}

.FourLinkagePanel .e-row,
.FourLinkagePanel .e-grid .e-altrow
{
	background: #000000;
}

.FourLinkagePanel .e-headercontent
{
	border: 0 none !important;
}

.FourLinkagePanel .e-grid .e-content{
    background-color: #000000;
}

.FourLinkagePanel .e-rowcell.e-lastrowcell{
    border-bottom-width: 0px !important;
}

.FourLinkagePanel .e-headertext{
	font-size: 12px;
}

.FourLinkagePanel .e-emptyrow{
	display: none;
}

.FourLinkagePanel .e-grid.e-gridhover tr[role='row']:not(.e-editedrow):hover .e-rowcell:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.FourLinkagePanel .e-grid.e-gridhover tr[role='row']:hover .e-detailrowcollapse:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.FourLinkagePanel .e-grid.e-gridhover tr[role='row']:hover .e-rowdragdrop:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.FourLinkagePanel .e-grid.e-rtl .e-gridhover tr[role='row']:hover .e-rowdragdrop:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell), 
.FourLinkagePanel .e-grid.e-gridhover tr[role='row']:hover .e-detailrowexpand:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell){
	color: #dddddd;
}

/*正常情况下滑块的样式*/
.FourLinkagePanel .e-content::-webkit-scrollbar-thumb {
   background-color: #dddddd;
   border-radius: 10px;
   -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}

/*鼠标悬浮在该类指向的控件上时滑块的样式*/
.FourLinkagePanel .e-content:hover::-webkit-scrollbar-thumb {
   background-color: #dddddd;
   border-radius: 10px;
   -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}

/*鼠标悬浮在滑块上时滑块的样式*/
.FourLinkagePanel .e-content::-webkit-scrollbar-thumb:hover {
    background-color: #aaaaaa;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}

/*正常时候的主干部分*/
.FourLinkagePanel .e-content::-webkit-scrollbar-track {
   border-radius: 10px;
   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
   background-color: #aaaaaa;

}

/*鼠标悬浮在滚动条上的主干部分*/
.FourLinkagePanel .e-content::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.4);
    background-color: #aaaaaa;
}

.FourLinkagePanel .e-grid td.e-active
{
	 background: #555;
}

.FourLinkagePanel .e-grid .e-rowcell{

	color: #dddddd;
}

#gridPOD.e-grid .e-content {
    max-height: 156px;
    overflow-y: scroll;
}

#gridService.e-grid .e-content {
    max-height: 160px;
    overflow-y: scroll;
}

.topo-title a:hover
{
	text-decoration: none;
}
</style>

